import { lazy } from "react";
import { RouteConfig } from "../routesConfig";

const TransferenciaVeiculo = lazy(() => import("../../../features/transferencia/TransferirVeiculoPage"));
const ExcluirVeiculo = lazy(() => import("../../../features/excluirVeiculo/ExcluirVeiculoPage"));

export const transferRoutes: RouteConfig[] = [
  { path: "/transferenciaVeiculos", component: TransferenciaVeiculo, private: true },
  { path: "/excluirVeiculo", component: ExcluirVeiculo, private: true, adminOnly: true },
];